import { lazy } from 'solid-js'
import { messages } from '../../pages/calendar-page/calendar-page-routing.messages.en.js'

// `:property_id?` mirrors `/bookings/:booking_id?`: the host lands on
// `/calendar` with nothing chosen, and choosing a listing pushes
// `/calendar/{property_id}` — so the view is linkable and survives a reload.
// The bare path deliberately does NOT pick a listing (CLAUDE.md
// non-negotiable #5); it prompts for one.
export default {
    component: lazy(() => import('../../pages/calendar-page/calendar-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/calendar/:property_id?',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showHostView: true,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
